import React from 'react'
import { Flex, Text } from 'theme-ui'

export const JiraProject = ({ label, avatar }) => (
  <Flex>
    <img width="16" src={avatar} alt="" />
    <Text sx={{ ml: 2 }}>{label}</Text>
  </Flex>
)
